<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit User Working days</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    
    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">

        <div class="form-group">
            <label>Month</label>
            <input type="text" class="form-control"  name="role" [(ngModel)]="MonthName" readonly>
        </div> 
        </div>
        
        <!---------------------------------------------------------->
        </div>

        <mat-form-field >
            <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates" name="excludedDates"
                                [(ngModel)]="model" [min]="minDate" [max]="maxDate">
            </ngx-multiple-dates>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>


          <div *ngIf=isShown class="loader"></div>
        <!-- <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
            <h4><i class="icon fas fa-check"></i> {{alert}}</h4>    
        </div> -->
        
        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick(); notification();">Submit</button>

    </div>
    </div>


